import './load-spinner.css';

function LoadSpinner(props) {
    return <div className="lds-ripple">
        <div></div>
        <div></div>
    </div>;
}
export default LoadSpinner;
